import clsx from "clsx";
import { SectionTitle, Subtitle, TextBadge } from "components/atoms/Text";
import PricingFeatureCard from "components/organism/Cards/PricingFeatureCard";
import { featureList } from "data";
import { Fragment, useState } from "react";
import DesktopFeatures from "./DesktopFeatures";

const MoreFeature = () => (
    <Fragment>
        {featureList.slice(3, 12).map((item) => (
            <PricingFeatureCard key={item.id} icons={item.icons} title={item.title} description={item.description} />))}
    </Fragment>
);

const Features = () => {
    const [loadMoreFeature, setLoadMoreFeature] = useState(false);
    const [hideLoadButton, setHideLoadButton] = useState(false);

    const loadMoreHandler = () => {
        setLoadMoreFeature(true);
        setHideLoadButton(true);
    };
    return (
        <section className="features w-full max-w-[1440px] mx-auto phone:py-12 tablet:py-[64px] py-[88px]">
            <section className={clsx(
                "w-full mx-auto max-w-full tablet:max-w-[632px] desktop:max-w-[790px] bg-neutral-10 text-center",
                "px-6 md:px-0"
            )}>
                <TextBadge>Features</TextBadge>
                <SectionTitle classNames="tablet:!text-[40px] tablet:!leading-[54px]">Why Buy Anonymous Proxies</SectionTitle>
                <Subtitle classNames="max-w-[607px] mx-auto">Our infrastructure is unique, battle-tested and carefully monitored by supervisors 24/7. There is no other proxy provider even close to operating at the same level and standards that we do.</Subtitle>
            </section>
            {/* Phone Device */}
            <section className={clsx(
                "md:hidden grid grid-cols-1 md:grid-cols-3 desktop:gap-x-8 desktop:gap-y-12 tablet:gap-8 phone:gap-y-10",
                "pt-16 tablet:pt-[67px] phone:pt-10 px-6 tablet:px-8 desktop:px-[120px]"
            )}>
                {featureList.slice(0, 3).map((item) => (
                    <PricingFeatureCard key={item.id} icons={item.icons} title={item.title} description={item.description} />))}
                {loadMoreFeature ? <MoreFeature /> : ""}
            </section>
            <DesktopFeatures />
            {hideLoadButton ? "" : <div className="block md:hidden px-6 mt-0 text-center">
                <button onClick={loadMoreHandler} className="py-[18px] phone:w-full h-[56px] flex items-center mx-auto justify-center leading-[19.83px] px-[33px] bg-primary-surface rounded-lg text-primary-main font-semibold text-md">Load More</button>
            </div>}
        </section>
    );
};

export default Features;